<template>
  <v-dialog v-model="localDialog" width="80%" @update:modelValue="updateDialog" transition="" persistent :open-delay="0" :close-delay="0">
    <v-card>
        <v-card-title class="text-h6">
            <span>{{ isEntryMode ? 'Add Branch' : 'Update Branch' }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
            <v-form @submit.prevent="submit" ref="BranchSetup">
              <v-row>
                  <v-col lg="4" md="4" cols="12"> 
                    <v-autocomplete
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      v-model="company_id.value.value"
                      :items="getCompanyList.filter(item=> item.status == 1)"
                      :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code}` : ''"                                                  
                      item-value="id"
                      :error-messages="company_id.errorMessage.value"
                      clearable                        
                    >
                      <template #label>
                        Company <span class="text-red-accent-4">*</span>
                      </template>
                    </v-autocomplete>  

                    <v-text-field
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      v-model="name.value.value"
                      :error-messages="name.errorMessage.value"
                      clearable
                    >
                      <template #label>
                        Name <span class="text-red-accent-4">*</span>
                      </template>
                    </v-text-field>

                    <v-text-field
                      label="Mobile"
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      v-model="mobile.value.value"
                      :error-messages="mobile.errorMessage.value"
                      clearable
                    >
                      <template #label>
                        Mobile <span class="text-red-accent-4">*</span>
                      </template>
                    </v-text-field>

                    <v-text-field
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      v-model="longitude.value.value"
                      :error-messages="longitude.errorMessage.value"
                      clearable
                    >
                      <template #label>
                        Longitude
                      </template>
                    </v-text-field>                                                       
                  </v-col>

                  <v-col lg="4" md="4" cols="12"> 
                    <v-text-field
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      v-model="email.value.value"
                      :error-messages="email.errorMessage.value"
                      clearable
                    >
                      <template #label>
                        Email <span class="text-red-accent-4">*</span>
                      </template>
                    </v-text-field>      
                    <v-textarea
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      v-model="address.value.value"
                      :error-messages="address.errorMessage.value"
                      clearable
                      auto-grow
                      rows="1"
                    >
                      <template #label>
                        Address <span class="text-red-accent-4">*</span>
                      </template>
                    </v-textarea>

                    <v-text-field
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      v-model="latitude.value.value"
                      :error-messages="latitude.errorMessage.value"
                      clearable
                    >
                      <template #label>
                        Latitude
                      </template>
                    </v-text-field>

                    <v-text-field
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      v-model="map_round.value.value"
                      :error-messages="map_round.errorMessage.value"
                      type="number"
                      step="0.01"
                      clearable
                    >
                      <template #label>
                        Map Round
                      </template>
                    </v-text-field>

                  </v-col>

                  

                  <v-col lg="4" md="4" cols="12">                                
                      
                    <v-file-input
                        v-model="selectedImage"
                        label="Company logo"
                        accept="image/*"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        show-size
                        @input="previewImage"                               
                        @click:clear="clearImage"
                        class="ellipsis-filename"
                        title="image"
                    >                                                                                                  
                    </v-file-input>

                    <div style="float: right;">
                        <v-img  :src="preview" cover  class="preview-image"></v-img>
                    </div>
                    
                      <v-checkbox                            
                          label="Active"
                          v-model="status.value.value"
                          :error-messages="status.errorMessage.value"
                          density="compact"
                          variant="outlined"
                          hide-details
                          single-line
                          color="primary"
                          value="1"
                      ></v-checkbox>
                      <input v-model="branch_id.value.value" type="hidden">
                  </v-col>
              </v-row>

              <v-divider></v-divider>
              <v-card-actions>
                  <v-layout class="justify-end">
                      <v-btn class="bg-red" variant="flat" type="reset"@click="closeDialog">Close</v-btn>
                        <v-btn 
                        class="bg-brand w-15 ms-2"  
                        variant="flat" 
                        type="submit"
                        >
                        {{ isEntryMode ? 'Save' : 'Update' }}
                        </v-btn>
                  </v-layout>
              </v-card-actions>
            </v-form>
        </v-card-text>
      
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'
import { fileServerUrl } from "@/store/api";

export default {
  name: 'CompanySetup',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        name: '',
        email: '',
        mobile: '',
        address: '',
        status: 1,
        company_id: null,
        branch_id: null,
        latitude: '',
        longitude: '',
        map_round: null,
      })
    }
  },
  data() {
    return {
      localDialog: this.dialog,
      selectedImage: null,
      errorMessages: '',
      preview: '/src/assets/no_preview.jpeg',
      loading: false,
      isEntryMode: true,
    }
  },
  computed: {
    getCompanyList() {
      return this.$store.getters.getCompanyList;
    },
  },
  watch: {
    dialog(val) {
      this.localDialog = val
    },
    localDialog(val) {
      this.$emit('update:dialog', val)
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.name.setValue(newData.name || '', false);
        this.email.setValue(newData.email || '', false);
        this.mobile.setValue(newData.mobile || '', false);
        this.address.setValue(newData.address || '', false);
        this.status.setValue(String(newData.status) || '1', false);
        this.company_id.setValue(newData.company_id || '', false);
        this.branch_id.setValue(newData.id || '', false);
        this.latitude.setValue(newData.latitude || '', false);
        this.longitude.setValue(newData.longitude || '', false);
        this.map_round.setValue(newData.map_round || null, false);
        this.preview = newData.logo ? fileServerUrl + newData.logo : '/src/assets/no_preview.png';
      },
    }
    
  },
  created() {
  },
  methods: {
    previewImage: function(event) {
        this.selectedImage = event.target.files[0];
        const input = event.target;
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = (e) => {
              this.preview = e.target.result;
            }
            this.image = input.files[0];
            reader.readAsDataURL(input.files[0]);
        }
        else {
            this.preview = '/src/assets/no_preview.jpeg';
        }
    },
    clearImage() {
        this.preview = '/src/assets/no_preview.jpeg';
    },
    updateDialog(val) {
      this.$emit('update:dialog', val)
    },
    closeDialog() {
        this.$emit('update:dialog', false);
    },
  },
  setup(props, { emit }){
    const { handleSubmit, resetForm} = useForm({
      validationSchema: yup.object({
          name: yup.string().min(1).max(50).required().trim().label('Name'),
          email: yup.string().email().max(50).required().trim().label('Email'),
          mobile: yup.string().min(7).max(15).required("Mobile Number is required").label('Mobile'),
          address: yup.string().min(5).max(150).required().trim().label('Address'),
          company_id: yup.number().positive().integer().required().label('Company Name'),
          latitude: yup.string().nullable().trim().label('Latitude'),
          longitude: yup.string().nullable().trim().label('Longitude'),
          map_round: yup.number().nullable().label('Map Round'),
      }),
    });

    const name = useField('name');
    const mobile = useField('mobile');
    const email = useField('email');
    const address = useField('address');
    const status = useField('status');
    const company_id = useField('company_id');
    const branch_id = useField('branch_id');
    const latitude = useField('latitude');
    const longitude = useField('longitude');
    const map_round = useField('map_round');
    const errorMessages  = ref('');
    const loading  = ref('');
    const selectedImage  = ref(null);
    const store = useStore();

    const submit = handleSubmit((values) => {

          // Create a FormData object
          const formData = new FormData();

          // Append all form values to FormData
          Object.keys(values).forEach((key) => {
              formData.append(key, values[key]);
          });

          // Append the selected image to FormData
          if (selectedImage.value) {
              formData.append('logo', selectedImage.value); // 'logo' is the key for the file
          }
  
        store.dispatch("saveUpdateBranchSetup", formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response) => {
                resetForm();
                emit('update:dialog', false);
                toast.success(response.data.message);
                loading.value = true;
                store.dispatch('getBranchList')
                    .then(data => {
                        loading.value = false;
                    })
                    .catch(error => {
                        loading.value = false;
                        toast.error(error.response.data.message);
                    })
            })
            .catch((error) => {            
                toast.error(error.response.data.message);          
            })
    });
    return {
      submit,
      name,
      mobile,
      email,
      address,
      status,
      errorMessages,
      selectedImage,
      company_id,
      branch_id,
      latitude,
      longitude,
      map_round,
      resetForm,
      loading
    }
  },
  mounted() {

  }
}
</script>

